export function convertLowerCaseNoAccent(text) {
  if (!text) return null
  return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}